import {getLinkSentinelHubStateKey} from '@account/utils/sentinel-hub';
import {useLocalStorage} from '@hooks/useLocalStorage';

export const useSentinelHubLinkState = id => {
  const [linkState] = useLocalStorage(getLinkSentinelHubStateKey(id));
  return {linkState};
};
